// extracted by mini-css-extract-plugin
module.exports = {"Loader":"fastViewService_Loader__y_ToL","Wrapper":"fastViewService_Wrapper__3yCit"};